import { render, staticRenderFns } from "./AllOrdersList.vue?vue&type=template&id=8f9ce56a&"
import script from "./AllOrdersList.vue?vue&type=script&lang=js&"
export * from "./AllOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports